import CONST from '@src/CONST';
import Platform from './types';

export default function getPlatform(): Platform {
    return CONST.PLATFORM.WEB;
}
